"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSentryContext = void 0;
const browser_1 = require("@sentry/browser");
const setSentryContext = (context) => {
    (0, browser_1.setContext)('ROARContext', context);
};
exports.setSentryContext = setSentryContext;
